import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MeasurementUnit } from '../models/measurementUnit';
import { ImperialDistanceUnit, MeasurementSystem } from '../models/measurementSystem';
import { SessionService } from '../services/session.service';

export const IMPERIAL_DISTANCE_UNIT_LABELS: Map<ImperialDistanceUnit, string> = new Map([
	['inches', 'COMMON.METRICS.INCHES'],
	['feet', 'COMMON.METRICS.FEET']
]);

export const IMPERIAL_SQUARE_DISTANCE_UNIT_LABELS: Map<ImperialDistanceUnit, string> = new Map([
	['inches', 'COMMON.METRICS.SQUARE_INCHES'],
	['feet', 'COMMON.METRICS.SQUARE_FEET']
]);

@Pipe({
    name: 'measurementUnit',
    standalone: true
})
export class MeasurementUnitPipe implements PipeTransform {

	constructor(private translate: TranslateService, private sessionService: SessionService) {}

	private getDistanceLabel(imperialUnit: ImperialDistanceUnit): string {
		let label: string;

		switch (this.sessionService.defaults.measurement_system) {
			case MeasurementSystem.Metrics:
				this.translate.get('COMMON.METRICS.METERS').subscribe((translate: string) => label = translate);
				break;
			case MeasurementSystem.Imperial:
				this.translate.get(IMPERIAL_DISTANCE_UNIT_LABELS.get(imperialUnit)).subscribe((translate: string) => label = translate);
				break;
			default: return label;
		}

		return label;
	}

	private getSquareDistanceLabel(imperialUnit: ImperialDistanceUnit): string {
		let label: string;

		switch (this.sessionService.defaults.measurement_system) {
			case MeasurementSystem.Metrics:
				this.translate.get('COMMON.METRICS.SQUARE_METERS').subscribe((translate: string) => label = translate);
				break;
			case MeasurementSystem.Imperial:
				this.translate.get(IMPERIAL_SQUARE_DISTANCE_UNIT_LABELS.get(imperialUnit)).subscribe((translate: string) => label = translate);
				break;
			default: return label;
		}

		return label;
	}

	private getMassLabel(): string {
		let label: string;

		switch (this.sessionService.defaults.measurement_system) {
			case MeasurementSystem.Metrics:
				this.translate.get('COMMON.METRICS.KILOGRAMS').subscribe((translate: string) => label = translate);
				break;
			case MeasurementSystem.Imperial:
				this.translate.get('COMMON.METRICS.POUNDS').subscribe((translate: string) => label = translate);
				break;
			default: return label;
		}

		return label;
	}

	transform(
		value: string | number,
		unit: MeasurementUnit,
		imperialDistanceUnit: ImperialDistanceUnit = 'inches'
	): string {
		let unitValue: string = '';

		switch (unit) {
			case 'mass': unitValue = this.getMassLabel(); break;
			case 'amount': this.translate.get('COMMON.METRICS.PSC').subscribe((translate: string) => unitValue = translate); break;
			case 'days': this.translate.get('COMMON.METRICS.DAYS').subscribe((translate: string) => unitValue = translate); break;
			case 'distance': unitValue = this.getDistanceLabel(imperialDistanceUnit ?? 'inches'); break;
			case 'squareDistance': unitValue = this.getSquareDistanceLabel(imperialDistanceUnit ?? 'inches'); break;
			default: return String(value);
		}
		
		return `${value}, ${unitValue}`;
	}
}
